import AdditionalServiceCategories from "@/views/premium-services/premium-service-categories/PremiumServiceCategories.vue";
import ConciergeServiceCreateDlg from "@/views/concierge/concierge-service-create-dlg/ConciergeServiceCreateDlg.vue";
import { batchUpdate } from "@/utils/batchUpdate";
import { ConciergeServicesListMixin } from "@/mixins/ConciergeServicesList.ts";
import { EventStatus } from "@/enums/EventStatus";
import moment from "moment";

export default {
  name: "ConciergeEvents",
  components: {
    AdditionalServiceCategories,
    ConciergeServiceCreateDlg,
  },
  mixins: [ConciergeServicesListMixin],
  data() {
    return {
      isShowPastEvents: false,
      currentDate: moment(new Date()).toDate(),
    }
  },
  computed: {
    EventStatus() {
      return EventStatus
    },
    serviceType() {
      return this.premiumServiceEventTypes.Event
    },
    additionalServices() {
      return this.$store.state.additionalServicesModule.additionalServices.filter(x => [
        this.premiumServiceEventTypes.EventBased,
        this.premiumServiceEventTypes.ConciergeEvent,
        this.premiumServiceEventTypes.Event,
      ].includes(x.type));
    },
    conciergeEvents() {
      const categoryObj = this.serviceCategories.find(x => x.name === this.category);

      let additionalServices = this.category && this.category !== 'All' && categoryObj && categoryObj?.id
        ? this.additionalServices.filter(service => service.categoryId === categoryObj?.id)
        : this.additionalServices;

      additionalServices = this.search
        ? additionalServices.filter(service => service.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
        : additionalServices;

      additionalServices = this.isShowPastEvents
        ? additionalServices.filter(service => moment(service?.start?.seconds * 1000).toDate() <= this.currentDate)
        : additionalServices.filter(service => moment(service?.start?.seconds * 1000).toDate() >= this.currentDate || !service?.hasOwnProperty('start'));

      return additionalServices.map((service) => ({
        id: service.id,
        image: service.imageUrl,
        name: service.name,
        category: service.category,
        categoryId: service.categoryId,
        price: service.subscriptionCost,
        time: moment(service.createdDateTime.seconds * 1000).format("L LT"),
        pending: this.serviceRequestsAwaiting.filter(x => x.serviceId === service.id).length,
        orderIndex: service.orderIndex,
        serviceType: service.serviceType,
        oneOffCost: service.oneOffCost,
        subscriptionCost: service.subscriptionCost,
        start: service?.start ? moment(service.start.seconds * 1000).format("DD/MM/YYYY LT") : "-",
        end: service?.end ? moment(service.end.seconds * 1000).toDate() : "-",
        isPublished: service?.isPublished ?? false
      })).sort((a, b) => {
        if(a.orderIndex < b.orderIndex) { return -1; }
        if(a.orderIndex > b.orderIndex) { return 1; }
        return 0;
      })
    },
  },
  methods: {
    async updateEvents() {
      this.loading = true;

      const itemsToUpdate = this.conciergeEvents.map((item, index) => {
        return { docId: item.id, updates: { orderIndex: index + 1 } };
      })

      await batchUpdate('additionalServices', itemsToUpdate).then(() => {
        this.loading = false;
      })
    }
  },
}